<template>
  <div class="profile-page-view">
    <div class="scroll-wrapper">
       <MyContent />
    </div>
    <AllNav />
  </div>
</template>

<script>
import MyContent from "../../components/my/MyContent.vue";
import AllNav from "../../components/footnav/AllNav.vue";

export default {
  name: 'AllMy',
  components: { MyContent, AllNav }
};
</script>

<style lang="scss" scoped>
.profile-page-view {
  background-color: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .scroll-wrapper {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 5rem;
  }
}
</style>